import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostMyStoreManager = () => {
	const navigate = useNavigate()
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (data) => {
		fetchRequest('POST', '/admin/store/my/manager', data)
	}

	useEffect(() => {
		if (!fetchResult) return

		switch (fetchResult.statusCode) {
			case 201:
			case 200:
				setAlert('매장 매니저 계정이 성공적으로 생성되었습니다.')
				navigate('/list/store')
				break
			case 400:
				if (fetchResult.data?.error_code === 'duplicate_id') {
					setAlert('이미 존재하는 아이디입니다.')
				} else {
					setAlert('입력 정보를 확인해 주세요.')
				}
				break
			case 403:
				setAlert('권한이 없습니다.')
				break
			case 409:
				setAlert('아이디 중복')
				break
			default:
				setAlert('알 수 없는 오류가 발생했습니다.')
				break
		}
	}, [fetchResult])

	return [request, isLoading]
}

export default usePostMyStoreManager
